import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import { API_URL } from 'utils';

const getAddress = async (keyword) => {
  try {
    const response = await axios.get(`${API_URL}/address/?district=${keyword}`, {
      headers: {
        Authorization: uuidv4(),
      },
    });
    return response.data;
  } catch (err) {
    throw err;
  }
};

export default getAddress;
